export default "__VITE_ASSET__CgazeVGO__"